<template>
  <transition @before-enter="onBeforeEnter" @after-enter="onAfterEnter">
    <div
      class="page-sub-menu-container"
      v-if="$store.state.subMeunSwitch"
      :class="{
        mobileMemberDetailShow: $store.state.mobileMemberDetailShow
      }"
      @click="onClose"
    >
      <div
        class="menu-list-container"
        :class="{
          menuHover: menuEnter
        }"
        @mouseenter="menuEnter = true"
        @mouseleave="menuEnter = false"
      >
        <router-link
          class="list__item"
          tag="div"
          v-for="(item, index) in lists"
          :key="index"
          :to="item.link"
          :class="{
            hoverActive: Number(currentIndex) === Number(index)
          }"
          @mouseenter.native="currentIndex = index"
          @mouseleave.native="currentIndex = -1"
        >
          <div class="item__text">
            <p v-if="item.hint">{{ item.hint }}</p>
            <p class="link__text">{{ item.name }}</p>
          </div>
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'c__sub-menu',
  data() {
    return {
      lists: [
        {
          name: 'project',
          hint: '50+',
          link: '/projects',
        },
        {
          name: 'about us',
          hint: 'Team',
          link: '/about',
        },
        // {
        //   name: 'news',
        //   hint: '',
        //   link: '/news',
        // },
        {
          name: 'jobs',
          hint: 'Join us',
          link: '/jobs',
        },
        {
          name: 'contact',
          hint: '',
          link: '/contact',
        },
      ],
      currentIndex: -1,
      menuEnter: false,
    };
  },
  methods: {
    onBeforeEnter(el) {
      console.log(el);
      el.classList.add('on-before-enter');
    },
    onAfterEnter(el) {
      el.classList.add('on-after-enter');
    },
    onMouseEnter() {
      console.log('111');
    },
    onClose() {
      this.$store.state.subMeunSwitch = false;
    },
  },
};
</script>

<style></style>
